module.exports = __webpack_public_path__ + "static/media/measures-min.be121e35.jpg";